<p style="font-size: 22px;">
  <strong>{{'movement.actualBalance' | translate}}</strong>: {{actualBalance}}
</p>
<app-kontable
  id="kon_movements_account_balance"
  title="{{ 'customers.loyalty_movements' | translate }}"
  [columns]="[
    {field: 'ShopDesc', title: 'customerDetail.domiciliationStores', bodyTemplate: shopTemplate},
    {field: 'Date', title: 'movement.xact_date', filterType: dateFilter},
    {field: 'Time', title: 'movement.xact_time'},
    'RegisterNo',
    'BillNo',
    'Amount',
    'ReasonDescr'
  ]"
  [titles]="[
    'movement.cash_desk',
    'movement.bill',
    'movement.value',
    'movement.reasonDescription'
  ]"
  [reportColumnWidth]="[115, 100, 120, 80, 65, 60, 105, 80, 160, 80, 70, 70]"
  [reportColumnType]="['STANDARD','STANDARD','STANDARD','DATE','TIME','STANDARD','STANDARD','STANDARD', 'STANDARD','STANDARD','STANDARD','STANDARD']"
  [reportColumnAlignment]="['left', 'left', 'left', 'center', 'center', 'center', 'left', 'right', 'left', 'right', 'right', 'right']"
  [isReportHor] = 'true'
  [source]="movements"
  [showGlobalFilter]="false"
  [showDetailsButton]="false"
  [showInfoButton]="false"
  [showRecoverButton]="false"
  [showAddButton]="false"
  [showEditButton]="false"
  [showDeleteButton]="false"
  [paginationType]="paginationType"
>

  <!-- Template Punto Vendita -->
  <ng-template #shopTemplate data-testid="shopTemplate" let-row>
    {{row.ShopId}} - {{row.ShopDesc}}
  </ng-template>
</app-kontable>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-account-balance/loyalty-account-balance-table-mg/loyalty-account-balance-table-mg.component.html